import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Grid,
  Button,
  Card,
  CardContent,
  CardHeader
} from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { Link as RouterLink } from 'react-router-dom';

const DashboardPage = () => {
  const { user, logout } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" align="center" gutterBottom>
        Welcome to Your Dashboard
      </Typography>
      
      <Paper sx={{ p: 4, mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          Account Information
        </Typography>
        <Box sx={{ mb: 3 }}>
          <Typography variant="body1">
            <strong>Name:</strong> {user?.name || 'User'}
          </Typography>
          <Typography variant="body1">
            <strong>Email:</strong> {user?.email || 'user@example.com'}
          </Typography>
          <Typography variant="body1">
            <strong>Account Type:</strong> {user?.stakeholderType || 'User'}
          </Typography>
        </Box>
        <Button 
          variant="contained" 
          color="primary"
          onClick={logout}
          component={RouterLink}
          to="/"
        >
          Logout
        </Button>
      </Paper>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader title="Recent Activity" />
            <CardContent>
              <Typography variant="body1">
                Your account was created successfully. Welcome to Laprecio!
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader title="Next Steps" />
            <CardContent>
              <Typography variant="body1" paragraph>
                Complete your profile to get the most out of our platform:
              </Typography>
              <Button 
                variant="outlined" 
                color="primary"
                component={RouterLink}
                to="/"
                sx={{ mr: 2 }}
              >
                Complete Profile
              </Button>
              <Button 
                variant="outlined" 
                color="secondary"
                component={RouterLink}
                to="/"
              >
                Explore Platform
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DashboardPage;
